import { ContractAddToCartPopupStates } from "~/features/contracts/components/AddToCartPopup/ContractAddToCartPopupStates";

export type ContractsStore = {
  popupData: {
    open: boolean;
    state: ContractAddToCartPopupStates;
    selectedQty?: number;
    selectedDate?: Date;
    errorMsg?: string;
  };
};

export const contractsInitialState: ContractsStore = {
  popupData: {
    open: false,
    state: ContractAddToCartPopupStates.LOADING,
  },
};

export interface UpdatedContractOverviewData {
  contractNumber: string;
  startDate?: Date;
  endDate?: Date;
  designation: string;
  materialNumber: string;
  customerMaterialNumber: string;
  disposition?: Date;
  status: string;
  detailsUrl: string;
  netPrice: {
    currencyIso: string;
    value: number;
    priceType: string;
    formattedValue: string;
  };
}
